// extracted by mini-css-extract-plugin
export var container = "featured-video-module--container--7aaf1";
export var content = "featured-video-module--content--f97e2";
export var playButton = "featured-video-module--playButton--44ae2";
export var poster = "featured-video-module--poster--ca669";
export var pulse = "featured-video-module--pulse--d679c";
export var videoWrapper = "featured-video-module--videoWrapper--386aa";
export var videoWrapperInner = "featured-video-module--videoWrapperInner--a0fc9";